var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m630 560h-560v-560h49v511h511z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m630 487.67h-147v-487.67h147zm-98-49h49v-389.67h-49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.67 487.67h-147v-366.34h147zm-98-49h49v-268.34h-49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m289.33 487.67h-147v-245h147zm-98-49h49v-147h-49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.b5b00df0f27befcf1f1cacebe28d385d.svg";
export { ForwardRef as ReactComponent };